// @ts-nocheck
import { selector } from "recoil";
import { noteTypes } from "./atom";

export const setNoteTypes = selector<any>({
  key: "setNoteTypes",
  get: () => null,
  set: ({ set }, noteTypesData) => {
    set(noteTypes, noteTypesData);
  },
});

export const getNoteTypes = selector<any>({
  key: "getNoteTypes",
  get: ({ get }) => {
    return get(noteTypes);
  },
});